import { c as _c } from "react/compiler-runtime";
import type { AnchorHTMLAttributes, ReactElement, ReactNode } from 'react';
import { buildButtonClassName, type Variant } from '#ui/button';
type BuildMailtoHrefArgs = {
  email: string;
  subject: string;
};
const buildMailtoHref = ({
  email,
  subject
}: BuildMailtoHrefArgs): string => `mailto:${email}?subject=${encodeURIComponent(subject)}`;
type MailtoButtonProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  email: string;
  subject: string;
  children: ReactNode;
  variant?: Variant;
};

/**
 * A pill button that opens the user's email client. Wears the design-system
 * `regular`-size button styling (`filled` by default) but renders an
 * `<a href="mailto:…">` so the browser hands off to the mail client rather
 * than running JS.
 */
export const MailtoButton = t0 => {
  const $ = _c(18);
  let children;
  let className;
  let email;
  let props;
  let subject;
  let t1;
  if ($[0] !== t0) {
    ({
      email,
      subject,
      children,
      variant: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = email;
    $[4] = props;
    $[5] = subject;
    $[6] = t1;
  } else {
    children = $[1];
    className = $[2];
    email = $[3];
    props = $[4];
    subject = $[5];
    t1 = $[6];
  }
  const variant = t1 === undefined ? "filled" : t1;
  let t2;
  if ($[7] !== email || $[8] !== subject) {
    t2 = buildMailtoHref({
      email,
      subject
    });
    $[7] = email;
    $[8] = subject;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== className || $[11] !== variant) {
    t3 = buildButtonClassName({
      variant,
      size: "regular",
      className
    });
    $[10] = className;
    $[11] = variant;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== children || $[14] !== props || $[15] !== t2 || $[16] !== t3) {
    t4 = <a href={t2} className={t3} {...props}>{children}</a>;
    $[13] = children;
    $[14] = props;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};